"use client";

import { BlockRenderer } from "@/components/blocks/BlockRenderer";
import { PublicFormRenderer } from "@/components/forms/PublicFormRenderer";
import type { PageTypeProps } from "@/components/page-types";
import { getSiteTemplateKey } from "@/lib/siteTemplates";

export function ContactPage({ page, tenantSettings }: PageTypeProps) {
  const layout = page.layout || "centered";
  const template = getSiteTemplateKey(tenantSettings);

  const hasFormBlock = page.blocks.some((block) => block.blockType === "form" && block.published);
  const form = <PublicFormRenderer slug="contact" showHeading={false} />;

  return (
    <section
      className={
        layout === "split"
          ? "mx-auto grid max-w-6xl gap-8 px-4 py-8 md:grid-cols-2"
          : layout === "sidebar"
            ? "mx-auto grid max-w-6xl gap-8 px-4 py-8 md:grid-cols-[1fr_320px]"
            : "mx-auto max-w-6xl px-4 py-8"
      }
    >
      <div>
        <h1 className="mb-6 text-3xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
          {page.title}
        </h1>
        <BlockRenderer blocks={page.blocks} template={template} heroStartsAtH2 />
        {!hasFormBlock && layout !== "sidebar" && layout !== "split" && form}
      </div>
      {!hasFormBlock && layout === "sidebar" && <aside>{form}</aside>}
      {!hasFormBlock && layout === "split" && <div>{form}</div>}
    </section>
  );
}
